import { render } from "./ContactUsButtonBar.vue?vue&type=template&id=2fdc789f"
import script from "./ContactUsButtonBar.vue?vue&type=script&lang=js"
export * from "./ContactUsButtonBar.vue?vue&type=script&lang=js"

import "./ContactUsButtonBar.vue?vue&type=style&index=0&id=2fdc789f&lang=css"
script.render = render

export default script